import { CreateButton, ExportButton, TopToolbar } from 'react-admin';
import { ImportButtonCSV } from './ImportButtonCSV';

export const ListActions = (props: object) => {
  return (
    <TopToolbar>
      <CreateButton />
      <ExportButton />
      <ImportButtonCSV {...props} />
    </TopToolbar>
  );
};
